module.exports = __webpack_public_path__ + "img/Garden_party.b9b010d.jpg";